import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '../services/util.service';

@Pipe({
  name: 'estDate'
})
export class EstDatePipe implements PipeTransform {
  transform(date: Date | undefined): Date | undefined {
    if (date) {
      return UtilService.estToLocal(date);
    } else {
      return;
    }
  }
}
